import { css } from '@emotion/css';

import { cn } from '@lyearn/style';

export const FILTER_INPUT_HEIGHT = 40;

const filterInputRootStyles = css`
  max-height: ${FILTER_INPUT_HEIGHT}px;
  background-color: var(--bg-primary);

  .MuiAutocomplete-input {
    min-width: 10px;
  }
`;

const optionBackground = css`
  &.MuiAutocomplete-option[aria-selected='true'] {
    background-color: transparent;
  }

  &.MuiAutocomplete-option[data-focus='true'] {
    background-color: var(--bg-secondary);
  }

  &.MuiAutocomplete-option[aria-disabled='true'] {
    opacity: 1;
  }
`;

const inputRootStyles = (height: number) => css`
  min-height: ${height}px;
  background-color: var(--bg-secondary);

  .MuiChip-root {
    margin: 0.2rem;
  }
`;

export const getClasses = (height: number) => ({
  inputRoot: cn('flex-wrap', inputRootStyles(height)),
  option: cn(
    'h-36 px-8 rounded-8 flex items-center justify-between cursor-pointer hover:bg-bg-secondary',
    optionBackground,
  ),
});

export const rectPositionStyles = ({ top, left, width, height }: DOMRect) => css`
  top: ${top}px;
  left: ${left}px;
  width: ${width}px;
  min-height: ${height}px;
  min-width: 30rem;

  .MuiOutlinedInput-root {
    border-radius: 0.4rem;
  }
`;

export const getFilterInputClasses = (height: number) => ({
  inputRoot: cn('flex-nowrap rounded-8', inputRootStyles(height), filterInputRootStyles),
});
